import { makeStyles } from '@material-ui/core/styles'
import { leftSidebarSettingsWidth } from 'src/Constants'

const sliderSubLabelText = {
  display: 'flex',
  justifyContent: 'center',
  fontSize: '0.8rem'
}

export const layerParametersStyle = makeStyles((theme) => ({
  root: {
    width: leftSidebarSettingsWidth,
    height: '100%',
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2),
    borderTop: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.primary.main,
    borderBottom: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.primary.main
  },
  discreteSlider: {
    display: 'flex',
    fontSize: '0.8rem'
  },
  slider: {
    color: theme.palette.primary.main
  },
  marksSlider: {
    color: theme.palette.primary.main,
    '& .MuiSlider-mark': {
      display: 'none'
    }
  },
  stepValueText: {
    display: 'flex',
    justifyContent: 'center'
  },
  sliderValueText: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '1.0rem'
  },
  sliderSubLabelText: {
    ...sliderSubLabelText,
    userSelect: 'none'
  },
  sliderSubLabelTextWithWikiDocument: {
    ...sliderSubLabelText,
    cursor: 'pointer'
  },
  valueStepDownButton: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  discreteRadio: {
    display: 'flex',
    marginBottom: 10,
    fontSize: '0.8rem'
  },
  radioGroup: {
    width: '100%'
  },
  radioLabel: {
    width: '100%',
    height: 35,
    marginLeft: 0,
    '& .MuiTypography-root': {
      fontSize: '0.9rem'
    }
  },
  discreteSwitch: {
    display: 'flex',
    marginBottom: 10,
    fontSize: '0.8rem'
  },
  switchLabel: {
    width: '100%',
    height: 35,
    marginLeft: 0,
    '& .MuiTypography-root': {
      fontSize: '0.8rem'
    }
  },
  input: {
    width: 50,
    height: 30,
    textAlign: 'center',
    borderRadius: theme.spacing(1),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.geoColors.toolBar.light,
    '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none'
    }
  },
  inputWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  valueWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  error: {
    backgroundColor: theme.palette.geoColors.error.main
  },
  normal: {
    backgroundColor: theme.palette.common.white
  },
  closeButton: {
    position: 'absolute',
    color: theme.palette.geoColors.headerText.main,
    right: 4,
    top: -5,
    zIndex: 1000
  },
  closeButtonIcon: {
    color: theme.palette.primary.main,
    fontSize: '1.2rem'
  },
  arrowButtonIcon: {
    color: theme.palette.primary.main,
    fontSize: '1.2rem'
  },
  message: {
    fontSize: '0.7rem',
    fontStyle: 'italic',
    paddingLeft: theme.spacing(1)
  }
}))
